/// <reference path="./index.d.ts" />
import fundsApi from './modules/funds';
import counterpartyApi from './modules/counterparty';


const api = {
	funds: fundsApi,
	counterparty: counterpartyApi,
};

export default api;
